import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import './index.css';

import 'bootstrap/dist/css/bootstrap.min.css';
// Bootstrap Bundle JS
import 'bootstrap/dist/js/bootstrap.bundle.min';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'react-toastify/dist/ReactToastify.css';
import 'react-datepicker/dist/react-datepicker.css';

import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './shared/api/queryClient.js';
import { RootStoreContext } from './shared/stores/context.js';
import { userStore } from './shared/stores/RootStore/rootStore.js';
import ErrorBoundary from './Pages/ErrorBoundary/ErrorBoundary.jsx';
import { ReCaptchaProvider } from './shared/providers/ReCaptchaProvider.jsx';

createRoot(document.getElementById('root')).render(
  <ErrorBoundary>
    <QueryClientProvider client={queryClient}>
      <RootStoreContext.Provider value={{ userStore }}>
        <BrowserRouter>
          <ReCaptchaProvider>
            <App />
          </ReCaptchaProvider>
        </BrowserRouter>
      </RootStoreContext.Provider>
    </QueryClientProvider>
  </ErrorBoundary>,
);
